import { DelegationRoles, UserRoles } from '../constants/user';

export interface UserProfileForm {
  firstName: string;
  surname: string;
  telephoneNumber: string;
  jobTitle: string;
  title: string;
  oldPassword?: string;
  password?: string;
  rPassword?: string;
}

export enum UserFeatureCode {
  UserApiKey = 'user_api_key',
}

interface ActiveFeature {
  code: UserFeatureCode;
  created: string;
}

interface UserPreferencesPlain {
  _id: string;
  userId: string;
  created: string;
  featureFlags: ActiveFeature[];
}

type EmptyUserPreferences = { userId: string };
export type UserPreferencesResponse = UserPreferencesPlain | EmptyUserPreferences

export interface UserMin {
  _id: string;
  firstName?: string;
  surname?: string;
  profile?: string;
  active?: boolean;
  jobTitle?: string; // Not on api UserMin?
  roles?: string[]; // Not on api UserMin?
  company?: string; // Not on api UserMin?
  contact?: string; // Not on api UserMin?
  email?: string;
  telephoneNumber?: string;
}

export interface UserPermissions {
  permissions: UserRoles[];
  initiativeId: string;
  expirationDate?: string;
}

export interface SafeUser extends UserMin {
  title: string;
  name?: string;
  stakeholderTypes: string[];
  partnerTypes?: string;
  lastLogin?: string;
  active: boolean;
  permissions: UserPermissions[];
  isStaff?: boolean;
  email?: string;
}

export type StatsUser = Pick<SafeUser, '_id' | 'permissions' | 'lastLogin' | 'isStaff' | 'firstName' | 'surname'> & {
  email: string;
  delegateDisabled?: boolean;
};

export interface SurveyDelegationUser extends UserMin {
  delegationRoles: DelegationRoles[];
}
